import axios from "axios";
import { Toast } from "vant";
axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
const service = axios.create({
  baseURL: "",
  timeout: 10000,
});
service.interceptors.request.use(
  (config) => {
    Toast.loading({
      message: "",
      duration: 0,
      forbidClick:true
    });
    return config;
  },
  (error) => {
    Toast.clear();
    console.log(error);
    return Promise.reject(error);
  }
);
service.interceptors.response.use(
  (response) => {
    Toast.clear();
    const res = response.data;
    if (res.status >= 0) {
      return response;
    } else {
      Toast.fail(res.statusInfo || "Error");
      return Promise.reject(new Error(res.statusInfo || "Error"));
    }
  },
  (error) => {
    Toast.clear();
    if (error.response.status >= 500) {
      Toast.fail("服务器错误");
    }

    return Promise.reject(error);
  }
);
export default service;
